import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input'];
  static values = {
    boardIds: Array,
    fpViewIds: Array,
  };

  toggle(event) {
    this.dispatch('toggled', {
      detail: {
        dimension: event.target.dataset.dimension,
        checked: event.target.checked,
      },
    });
  }

  render(dimension, selected, total) {}

  hasDimension(dimension) {
    return !!this.inputFor(dimension);
  }

  inputFor(dimension) {
    return this.inputTargets.find((input) => input.dataset.dimension === dimension);
  }

  get childIds() {
    return { boardIds: this.boardIdsValue, fpViewIds: this.fpViewIdsValue };
  }
}
